import { ApiVersion } from "../constants/api.constants";

const API_VERSION = ApiVersion.V4;

export const ENDPOINTS = {
  login: `login`,
  groups: `${API_VERSION}/groups`,
  archivedGroups: `${API_VERSION}/groups/archived`,
  user: `${API_VERSION}/users/me`,
  numericMeter: `${API_VERSION}/users/numeric-meters`,
  getUserPermissions: `${API_VERSION}/users/permissions`,
  maintenanceReportsMasterData: `${API_VERSION}/users/maintenance-reports/masterData`,
  getTradeMarkData: `${API_VERSION}/users/tradeMark/data`,
  putUser: `${API_VERSION}/users/me`,
  machineManufacturers: `${API_VERSION}/users/me/machineManufacturers`,
  machineTypes: `${API_VERSION}/users/me/machineTypes`,
  getSampleItemsMediaData: `${API_VERSION}/users/me/sampleItemsMediaData`,

  machineTemplatePathUrl: `${API_VERSION}/users/me/machineTemplateFileUrl`,
  getNotifications: `${API_VERSION}/notifications`,
  getUnreadCountNotifications: `${API_VERSION}/notifications/unread-count`,

  createAnnouncement: `${API_VERSION}/announcements`,
  getAnnouncements: `${API_VERSION}/announcements`,
  getTranslationPermissions: `${API_VERSION}/translations/permissions`,
  exportTranslationsZip: `${API_VERSION}/translations/export/zip`,
  exportTranslationsXlsx: `${API_VERSION}/translations/export/xlsx`,
  exportTranslationsSqlWeb: `${API_VERSION}/translations/export/sql/web`,
  exportTranslationsSqlApi: `${API_VERSION}/translations/export/sql/api`,
  exportTranslationsSqlMobile: `${API_VERSION}/translations/export/sql/mobile`,
  apiImportDBTranslations: `${API_VERSION}/translations/importDBTranslations`,
  createTranslation: `${API_VERSION}/translations/create`,
  updateTranslation: `${API_VERSION}/translations/update`,
  bulkUpdateTranslations: `${API_VERSION}/translations/bulk-update`,
  deleteTranslation: `${API_VERSION}/translations/delete`,
  getGlobalAnnouncements: `${API_VERSION}/announcements/global`,
  getPopupAnnouncements: `${API_VERSION}/announcements/popups`,
  getUnreadCountAnnouncements: `${API_VERSION}/announcements/unread-count`,
  getGlobalAnnouncementPermissions: `${API_VERSION}/announcements/global/permission`,
  deleteAnnouncement: `${API_VERSION}/announcements/`,
  deleteAnnouncementGlobal: `${API_VERSION}/announcements/global`,
  announcementMarkRead: `${API_VERSION}/announcements/mark-read/`,
  hideMultipleAnnouncementPopup: `${API_VERSION}/announcements/hide-multiple-popups`,
  getOtherAnnouncementsTemplate: `${API_VERSION}/announcements/AnnouncementTemplateFileUrl`,

  getUserAdminPermissions: `${API_VERSION}/users/admin/permissions`,
  putUserAdminPermissions: `${API_VERSION}/users/admin/permissions`,
  restoreUser: (userId: string) =>
    `${API_VERSION}/account-deletion/restore/${userId}`,

  getBlankInspectionFormTemplate: (groupId: string, machineId: string) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/BlankInspectionFormTemplateFileUrl`,

  userSettings: `${API_VERSION}/users/settings`,
  reportsPrintLimit: `${API_VERSION}/users/reports/print-limit`,
  reportsMediaCount: `${API_VERSION}/users/reports/media-count`,
  groupDetail: (id: string) => `${API_VERSION}/groups/${id}`,
  groupDetailCondition: (id: string) =>
    `${API_VERSION}/groups/${id}/conditions`,
  groupIsAbnormality: (id: string) =>
    `${API_VERSION}/groups/${id}/is-abnormality`,

  apiGetGroup: (id: string) => `${API_VERSION}/groups/${id}`,

  postTOURecordHistory: `${API_VERSION}/users/me/TOURecordHistory`,

  groupDetailInspectionForms: (id: string) =>
    `${API_VERSION}/groups/${id}/inspection-forms`,

  getTOUVersionMaster: (residenceCountryCode: string) =>
    `${API_VERSION}/users/me/touVersionMaster/${residenceCountryCode}`,

  deleteTOUVersion: `${API_VERSION}/users/me/touVersionMaster`,

  getTOUVersionMasterAll: `${API_VERSION}/users/me/touVersionMaster`,

  postTOUVersionMaster: `${API_VERSION}/users/me/touVersionMaster`,

  updateTOUVersionMaster: `${API_VERSION}/users/me/touVersionMaster`,

  groupDetailInspectionDeleteOrUpdate: (
    groupId: string,
    machineId: string,
    customInspectionFormId: string,
  ) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/inspection-forms/${customInspectionFormId}`,

  updateInspectionFormAndItemsWeb: (
    machineId: string,
    customInspectionFormId: string,
  ) =>
    `${API_VERSION}/users/machines/${machineId}/inspection-forms/${customInspectionFormId}/items/Web`,

  updateInspectionFormAndItemsWebNew: (customInspectionFormId: string) =>
    `${API_VERSION}/users/inspection-forms/${customInspectionFormId}/items/Web`,

  updateInspectionFormStatus: (
    groupId: string,
    machineId: string,
    customInspectionFormId: string,
  ) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/inspection-forms/${customInspectionFormId}/status`,

  updateInspectionFormStatusNew: (customInspectionFormId: string) =>
    `${API_VERSION}/users/inspection-forms/${customInspectionFormId}/status`,

  customInspectionFormDetail: (
    groupId: string,
    machineId: string,
    customInspectionFormId: string,
  ) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/inspection-forms/${customInspectionFormId}`,

  customInspectionFormDetailNew: (customInspectionFormId: string) =>
    `${API_VERSION}/users/inspection-forms/${customInspectionFormId}`,

  customInspectionFormDetails: (
    groupId: string,
    machineId: string,
    customInspectionFormId: string,
  ) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/inspection-forms/${customInspectionFormId}/web`,

  deleteInspection: (
    groupId: string,
    machineId: string,
    inspectionId: string,
  ) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/inspections/${inspectionId}`,

  inspectionDetail: (
    groupId: string,
    machineId: string,
    inspectionId: string,
  ) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/inspections/${inspectionId}`,

  groupDetailInspectionFormStatus: (id: string) =>
    `${API_VERSION}/groups/${id}/inspection-form-status`,

  groupMachinesDetail: (id: string) => `${API_VERSION}/groups/${id}/machines`,

  machinesTransferGroups: (groupId: string) =>
    `${API_VERSION}/groups/${groupId}/machinesTransferGroups`,

  updateMachineInGroup: (groupId: string, machineId: string) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}`,

  deleteMachineInGroup: (groupId: string, machineId: string) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}`,

  deleteMachineInGroupBulk: (groupId: string) =>
    `${API_VERSION}/groups/${groupId}/machines/DeleteBulk`,

  deleteGroupsInBulk: () => `${API_VERSION}/groups`,

  archiveGroupsInBulk: () => `${API_VERSION}/groups/archive-status`,

  addGroup: () => `${API_VERSION}/groups/`,

  updateGroup: (groupId: string) => `${API_VERSION}/groups/${groupId}`,

  transferMachinesInGroupBulk: () =>
    `${API_VERSION}/users/transferMachinesGroup`,

  updateMachineInGroupStatus: (groupId: string, machineId: string) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/machine-conditions`,

  postMachineInGroup: (groupId: string) =>
    `${API_VERSION}/groups/${groupId}/machines`,

  postMachineBulkInGroup: (groupId: string) =>
    `${API_VERSION}/groups/${groupId}/machines/bulk`,

  PostInspectionFormMultipleGroupsMachines: () =>
    `${API_VERSION}/groups/inspection-forms/multiple`,

  PostInspectionFormMultipleGroupsMachinesNew: () =>
    `${API_VERSION}/users/customInspectionFormMachines`,

  groupMachineManufacturers: (groupId: string) =>
    `${API_VERSION}/groups/${groupId}/machineManufacturers`,

  Getusergroups: (userId: string) =>
    `${API_VERSION}/users/${userId}/usergroups`,

  groupMachineTypes: (groupId: string) =>
    `${API_VERSION}/groups/${groupId}/machinetype`,

  groupMachineAvailable: (groupId: string) =>
    `${API_VERSION}/groups/${groupId}/available-machines`,

  groupMachineAvailableWeb: (groupId: string) =>
    `${API_VERSION}/groups/${groupId}/available-machines/web`,

  groupMachineTypeWeb: (groupId: string, machineTypeId: string) =>
    `${API_VERSION}/groups/${groupId}/machineTypeId/${machineTypeId}/machines`,

  groupMachineTypeWebNew: (groupIds: string) =>
    `${API_VERSION}/users/machinesAssignmentForms?groupIds=${groupIds}`,

  groupsMachinesReportsCSV: (
    machineIds: string,
    startDate: string,
    endDate: string,
    timeZone: string,
  ) =>
    `${API_VERSION}/users/groups/machines/reports/csv?machineIds=${machineIds}&startDate=${startDate}&endDate=${endDate}&timeZone=${timeZone}`,

  groupsMachinesReportsCSVGroup: (
    groupId: string,
    startDate: string,
    endDate: string,
    timeZone: string,
  ) =>
    `${API_VERSION}/users/groups/machines/reports/csv/groups/${groupId}?startDate=${startDate}&endDate=${endDate}&timeZone=${timeZone}`,

  groupsMachinesReportsSummaryList: (
    groupId: string,
    layoutMode: string,
    month: string,
    date: string,
    timeZone: string,
    reportType: string,
    page: string,
    limit: string,
    order?: string,
    orderBy?: string,
    showAll?: boolean,
    search?: string,
    isAllDateRange?: boolean,
  ) => {
    let url = `${API_VERSION}/machine-report-history/${groupId}/machines/reports/summary/list?`;

    if (layoutMode) url += `layoutMode=${layoutMode}&`;
    if (month) url += `month=${month}&`;
    if (date) url += `date=${date}&`;

    url += `timeZone=${timeZone}&reportType=${reportType}&limit=${limit}&page=${page}`;

    if (order) url += `&order=${order}`;
    if (orderBy) url += `&orderBy=${orderBy}`;

    if (typeof showAll !== "undefined") {
      url += `&showAll=${showAll}`;
    }
    if (search && search.trim() !== "") {
      url += `&search=${encodeURIComponent(search)}`;
    }
    if (typeof isAllDateRange !== "undefined") {
      url += `&isAllDateRange=${isAllDateRange}`;
    }

    return url;
  },

  translationsList: (
    page: string,
    limit: string,
    order?: string,
    orderBy?: string,
    search?: string,
    platform?: string,
  ) => {
    let url = `${API_VERSION}/translations?page=${page}&limit=${limit}`;

    if (order) url += `&sortOrder=${order}`;
    if (orderBy) url += `&sortBy=${orderBy}`;

    if (search && search.trim() !== "") {
      url += `&search=${encodeURIComponent(search)}`;
    }

    if (platform && platform !== "all") {
      url += `&platform=${platform}`;
    }

    return url;
  },

  groupsMachinesReportsSummaryGrid: (
    groupId: string,
    layoutMode: string,
    month: string,
    date: string,
    timeZone: string,
    reportType: string,
    page: string,
    limit: string,
    order?: string,
    orderBy?: string,
    showAll?: boolean,
    search?: string,
  ) => {
    let url = `${API_VERSION}/machine-report-history/${groupId}/machines/reports/summary/grid?`;

    if (layoutMode) url += `layoutMode=${layoutMode}&`;
    if (month) url += `month=${month}&`;
    if (date) url += `date=${date}&`;

    url += `timeZone=${timeZone}&reportType=${reportType}&limit=${limit}&page=${page}`;

    if (order) url += `&order=${order}`;
    if (orderBy) url += `&orderBy=${orderBy}`;

    if (typeof showAll !== "undefined") {
      url += `&showAll=${showAll}`;
    }
    if (search && search.trim() !== "") {
      url += `&search=${encodeURIComponent(search)}`;
    }

    return url;
  },

  machineInfo: (groupId: string, machineId: string) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}`,

  machineDetailInfo: (groupId: string, machineId: string) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}`,

  apiGetMachineManufTypes: (groupId: string) =>
    `${API_VERSION}/groups/${groupId}/machinesManuTypes`,

  machineReport: (groupId: string, machineId: string) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/machine-reports`,

  inspectionFormTemplates: (groupId: string, machineId: string) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/inspection-form-templates`,

  inspectionFormTemplatesAll: (groupId: string, machineId: string) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/inspection-form-templates/all`,

  inspectionForms: (groupId: string, machineId: string) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/inspection-forms`,

  inspectionFormsWeb: (groupId: string, machineId: string) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/inspection-forms/web`,

  inspectionFormDetail: (
    groupId: string,
    machineId: string,
    inspectionFormId: string,
  ) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/inspection-form-templates/${inspectionFormId}`,

  updateInspectionItemStatus: (
    groupId: string,
    machineId: string,
    inspectionItemId: string,
  ) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/inspection-forms-items/${inspectionItemId}`,

  inspectionForm: (groupId: string, machineId: string) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/inspection-forms`,
  uploadUrls: `/${API_VERSION}/blob-storage/generate-video-upload-urls`,
  uploadStore: "",

  machineReportResponses: (
    groupId: string,
    machineId: string,
    machineReportId: string,
  ) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/machine-reports/${machineReportId}/machine-report-responses`,

  machineReportStatus: (
    groupId: string,
    machineId: string,
    machineReportId: string,
  ) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/machine-reports/${machineReportId}/read-status`,

  inspections: (groupId: string, machineId: string) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/inspections`,

  machineReportActionChoices: () => `${API_VERSION}/report-action-choices`,
  machineReportDetail: (
    groupId: string,
    machineId: string,
    machineReportId: string,
  ) =>
    `/${API_VERSION}/groups/${groupId}/machines/${machineId}/machine-reports/${machineReportId}`,

  machineReportOriginal: (
    groupId: string,
    machineId: string,
    machineReportId: string,
  ) =>
    `/${API_VERSION}/groups/${groupId}/machines/${machineId}/machine-reports/${machineReportId}/original`,

  machineDetails: (groupId: string) =>
    `/${API_VERSION}/groups/${groupId}/GetMachines/`,

  groupMachinesDetailsList: (groupId: string) =>
    `${API_VERSION}/users/groups/${groupId}/machines/details`,

  inspectionPdf: (groupId: string, machineId: string) =>
    `/${API_VERSION}/groups/${groupId}/machines/${machineId}/inspection-pdf`,

  inspectionsPdf: (groupId: string, machineId: string, inspectionId: string) =>
    `/${API_VERSION}/pdfReports/groups/${groupId}/machines/${machineId}/inspections/${inspectionId}/generate-inspection-pdf`,

  monthlyInspectionsPdf: (
    groupId: string,
    machineId: string,
    customInspectionFormId: string,
  ) =>
    `/${API_VERSION}/pdfReports/groups/${groupId}/machines/${machineId}/customInspectionForms/${customInspectionFormId}/generate-monthly-inspection-pdf`,

  exportExcel: (groupId: string) =>
    `/${API_VERSION}/groups/${groupId}/export-machines-excel`,

  machinesPdf: (groupId: string, machineId: string, machineReportId: string) =>
    `/${API_VERSION}/pdfReports/groups/${groupId}/machines/${machineId}/machineReports/${machineReportId}/generate-abnormality-pdf`,

  machineNameInfo: (reportId: string) =>
    `/${API_VERSION}/pdfReports/reports/${reportId}/pdf/fileName/info`,

  monthlyInspectionInfo: (
    groupId: string,
    machineId: string,
    customInspectionFormId: string,
  ) =>
    `/${API_VERSION}/pdfReports/groups/${groupId}/machines/${machineId}/customInspectionForms/${customInspectionFormId}/monthly-inspection-info-table`,

  machineNameInfoMaintenance: (
    groupId: string,
    machineId: string,
    reportId: string,
  ) =>
    `/${API_VERSION}/pdfReports/groups/${groupId}/machines/${machineId}/machineReports/${reportId}/maintenance-table-title`,

  machinesMaintenancePdf: (
    groupId: string,
    machineId: string,
    machineReportId: string,
  ) =>
    `/${API_VERSION}/pdfReports/groups/${groupId}/machines/${machineId}/machineReports/${machineReportId}/generate-maintenance-pdf`,

  bulkReportsPdf: (groupId: string, machineId: string) =>
    `/${API_VERSION}/pdfReports/groups/${groupId}/machines/${machineId}/generate-reports-pdf/bulk`,

  machineOperationReport: (
    groupId: string,
    machineId: string,
    machineReportId: string,
  ) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/machine-operation-reports/${machineReportId}`,

  fuelMaintenanceReportNew: (groupId: string, machineId: string) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/fuel-maintenance-reports/new`,

  maintenanceReportNew: (groupId: string, machineId: string) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/maintenance-reports`,

  machineFuelMaintenanceReport: (
    groupId: string,
    machineId: string,
    machineReportId: string,
  ) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/fuel-maintenance-reports/new/${machineReportId}`,

  machineReportInfo: (groupId: string, machineId: string) =>
    `/${API_VERSION}/groups/${groupId}/machines/${machineId}/machine-report-info`,
  machineSummary: (groupId: string, machineId: string) =>
    `/${API_VERSION}/groups/${groupId}/machines/${machineId}/summary`,
  maintenanceReport: (
    groupId: string,
    machineId: string,
    machineReportId: string,
  ) =>
    `/${API_VERSION}/groups/${groupId}/machines/${machineId}/maintenance-reports/${machineReportId}`,

  maintenanceReportDraft: (groupId: string, machineId: string) =>
    `/${API_VERSION}/groups/${groupId}/machines/${machineId}/maintenance-reports/draft`,

  maintenanceReportDraftList: (groupId: string, machineId: string) =>
    `/${API_VERSION}/groups/${groupId}/machines/${machineId}/maintenance-reports/draft/list`,

  maintenanceReportDraftDetail: (
    groupId: string,
    machineId: string,
    machineReportId: string,
  ) =>
    `/${API_VERSION}/groups/${groupId}/machines/${machineId}/maintenance-reports/${machineReportId}/draft`,

  inspectionItemRecords: (
    groupId: string,
    machineId: string,
    inspectionId: string,
    timezone: string,
  ) =>
    `/${API_VERSION}/groups/${groupId}/machines/${machineId}/inspections/${inspectionId}/inspectionItemsRecords?timezone=${timezone}`,

  createInspection: (groupId: string, machineId: string) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/inspections`,

  latestInspection: (groupId: string, machineId: string) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/latest-inspection`,

  getInspectionDetail: (
    groupId: string,
    machineId: string,
    inspectionId: string,
  ) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/inspections/${inspectionId}`,

  getInspectionItemDetail: (
    groupId: string,
    machineId: string,
    inspectionId: string,
    inspectionItemId: string,
  ) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/inspections/${inspectionId}/customInspectionItemId/${inspectionItemId}`,

  updateInspection: (
    groupId: string,
    machineId: string,
    inspectionId: string,
  ) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/inspections/${inspectionId}`,

  updateInspectionFiltered: (
    groupId: string,
    machineId: string,
    inspectionId: string,
  ) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/inspections/${inspectionId}/filtered`,

  updateInspectionItem: (
    groupId: string,
    machineId: string,
    inspectionId: string,
    inspectionResultId: string,
  ) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/inspections/${inspectionId}/inspectionResultId/${inspectionResultId}`,

  getInspectionAt: (groupId: string, machineId: string, inspectionId: string) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/inspections/${inspectionId}/inspection-at`,

  updateInspectionAt: (
    groupId: string,
    machineId: string,
    inspectionId: string,
  ) =>
    `${API_VERSION}/groups/${groupId}/machines/${machineId}/inspections/${inspectionId}/inspection-at`,

  deleteNotifications: (notificationId: string, userId: string) =>
    `${API_VERSION}/notifications/${notificationId}/${userId}`,

  notificationMarkRead: (notificationId: string) =>
    `${API_VERSION}/notifications/mark-read/${notificationId}`,

  getMachineLocations: (groupId: string) =>
    `${API_VERSION}/groups/${groupId}/machinesLocations`,

  pendingUsersWeb: (
    groupId: string,
    page: number,
    limit: number,
    order?: string,
    orderBy?: string,
    search?: string,
  ) => {
    let url = `${API_VERSION}/groups/${groupId}/group/pending/users/web?page=${page}&limit=${limit}`;

    if (order) url += `&order=${order}`;
    if (orderBy) url += `&orderBy=${orderBy}`;
    if (search && search.trim() !== "") {
      url += `&search=${encodeURIComponent(search)}`;
    }

    return url;
  },

  assignedUsersWeb: (
    groupId: string,
    page: number,
    limit: number,
    order?: string,
    orderBy?: string,
    search?: string,
  ) => {
    let url = `${API_VERSION}/groups/${groupId}/group/assigned/users/web?page=${page}&limit=${limit}`;

    if (order) url += `&order=${order}`;
    if (orderBy) url += `&orderBy=${orderBy}`;
    if (search && search.trim() !== "") {
      url += `&search=${encodeURIComponent(search)}`;
    }

    return url;
  },

  apiGetRoleTemplatePermissions: () => `${API_VERSION}/group-role-templates`,

  apiGetUserAssignmentInfo: (groupId: string, userId: string) =>
    `${API_VERSION}/groups/${groupId}/users/${userId}/user-assignment-info`,

  apiDeleteUserAssignmentInfo: (groupId: string, userId: string) =>
    `${API_VERSION}/groups/${groupId}/users/${userId}/user-assignment-info`,

  apiDenyUserAssignmentInfo: (groupId: string, userId: string) =>
    `${API_VERSION}/groups/${groupId}/inviteeUserId/${userId}/declined`,

  apiUpdateUserAssignmentInfo: (groupId: string, userId: string) =>
    `${API_VERSION}/groups/${groupId}/users/${userId}/user-assignment-info`,

  apiAddUserAssignmentInfo: (groupId: string) =>
    `${API_VERSION}/groups/${groupId}/users/invitations`,

  apiCandidateUsersWeb: (groupId: string) =>
    `${API_VERSION}/groups/${groupId}/candidate-users`,
  apiCandidateUsersSearchWeb: (groupId: string, search: string) =>
    `${API_VERSION}/groups/${groupId}/candidate-users/new?search=${encodeURIComponent(
      search,
    )}`,

  apiSearchUsers: (search: string) =>
    `${API_VERSION}/users/search?search=${encodeURIComponent(search)}`,

  tenantInfo: (email: string) =>
    `${API_VERSION}/ga/tenant-info?userEmail=${encodeURIComponent(email)}`,

  acrossGroupMachinesMachines: `${API_VERSION}/acrossGroupMachines/machines`,

  checkBlockedCountry: `${API_VERSION}/users/checkBlockedCountry`,

  apiPeriodicMaintenanceSchedule: (modelType: string, intervalCode: string) =>
    `${API_VERSION}/periodic-maintenance/schedule?modelType=${encodeURIComponent(
      modelType,
    )}&intervalCode=${encodeURIComponent(intervalCode)}`,

  apiPeriodicMaintenanceAvailability: (modelType: string) =>
    `${API_VERSION}/periodic-maintenance/availability?modelType=${encodeURIComponent(
      modelType,
    )}`,

  periodicMaintenanceTemplateFileUrl: `${API_VERSION}/periodic-maintenance/template-file-url`,
  periodicMaintenanceBulkImport: `${API_VERSION}/periodic-maintenance/bulk-import`,
  periodicMaintenanceMasterList: (
    page: string,
    limit: string,
    order?: string,
    orderBy?: string,
    search?: string,
    work?: string,
    countryCode?: string,
  ) => {
    let url = `${API_VERSION}/periodic-maintenance/master-data?page=${page}&limit=${limit}`;
    if (order) url += `&sortOrder=${order}`;
    if (orderBy) url += `&sortBy=${orderBy}`;
    if (search && search.trim() !== "")
      url += `&search=${encodeURIComponent(search)}`;
    if (work) url += `&work=${encodeURIComponent(work)}`;
    if (countryCode) url += `&countryCode=${countryCode}`;
    return url;
  },
  periodicMaintenanceMasterDataDelete: `${API_VERSION}/periodic-maintenance/master-data`,
  periodicMaintenanceMasterDataUpdate: (periodicMaintenanceMachineItemId: string) =>
    `${API_VERSION}/periodic-maintenance/master-data/${periodicMaintenanceMachineItemId}`,
  periodicMaintenanceMasterDataDetail: (periodicMaintenanceMachineItemId: string) =>
    `${API_VERSION}/periodic-maintenance/master-data/${periodicMaintenanceMachineItemId}`,
  maintenanceReportTemplates: `${API_VERSION}/maintenance-report-templates`,
};
